export enum TemplateType {
  Document = "Document"
}